import { IDashboardStat } from '../../../ts/interface/dashboardStats.interface';
import { IOrganizationDashboardResumenProps } from '../../../ts/interface/pages/dashboard.interface';
import { formatNumberWithCommas, history } from '../../../utils';
import QuickStats from '../../../components/Redesing/quick-stats';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import LineChartUp04Icon from '../../../icons/untitled-ui/duocolor/line-chart-up-04';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import BikeScooterIcon from '@mui/icons-material/BikeScooter';

function ResumeDashboard({
  organizationId,
  stats,
  isLoading,
}: IOrganizationDashboardResumenProps) {
  const dashboardStats = stats || ({} as IDashboardStat);
  const pluralUnits = 'Hardware';

  return (
    <div>
      <QuickStats
        sections={[
          {
            title: 'Active Rentals',
            id: 'active-rentals',
            value: formatNumberWithCommas(dashboardStats?.active_rentals || 0),
            icon: <DirectionsBikeIcon />,
            onClick: () => {
              history.push(`/rentals?organizationId=${organizationId}&status=active`);
            },
          },
          {
            title: 'Total Rentals',
            id: 'total-rentals',
            value: formatNumberWithCommas(dashboardStats?.total_rentals || 0),
            icon: <LineChartUp04Icon />,
            onClick: () => {
              history.push(`/rentals?organizationId=${organizationId}&status=all`);
            },
          },
          {
            title: 'Total Users',
            id: 'total-users',
            value: formatNumberWithCommas(dashboardStats?.total_users || 0),
            icon: <PeopleOutlineIcon />,
            onClick: () => {
              history.push(`/users?organizationId=${organizationId}`);
            },
          },
          {
            title: `Available ${pluralUnits || ''}`,
            id: 'available-hardware',
            value: formatNumberWithCommas(dashboardStats?.available_hardware || 0),
            icon: <BikeScooterIcon />,
            onClick: () => {
              history.push(
                `/hardware?organizationId=${organizationId}&type=bike&status=active`
              );
            },
          },
        ]}
        // See the note in dashboardResume: only until the first response. Keying
        // this off total_rentals instead meant an organization with no rentals
        // re-entered the loading state on every refetch.
        isLoading={!stats && isLoading}
      />
    </div>
  );
}

export default ResumeDashboard;
